import React, { FC } from "react";
import "./SearchResult.styles.css";
import { SearchResultProps } from "./SearchResult.interface";
import { Link } from "react-router-dom";

export const SearchResult: FC<SearchResultProps> = ({
  uuid,
  name,
  type,
  description,
  startTime,
  teams,
  sport
}) => {
  return (
    <Link
      to={`/${type}/${uuid}`}
      style={{ textDecoration: "none", color: "#fff" }}
    >
      <div>
        {/* <span className='subtitle'>Soccer | Premier League | Men</span> */}
        <div className="match-logos">
          {teams?.map(({ name, logoUrl }, index) => (
            <>
              <img
                key={name}
                className="search-logo-size"
                src={logoUrl ?? "/default-team-logo.svg"}
                alt={name}
              />
              {teams?.length - 1 !== index && "vs."}
            </>
          ))}
          <h4>
            <strong>
              {name} {startTime && new Date(startTime).toLocaleDateString()}
            </strong>
          </h4>
        </div>
        <p>{description}</p>
      </div>
    </Link>
  );
};
